import apiClient from "./apiClient";
import { API_ENDPOINTS } from "./header";

export const warrantyApi = {
  list: (params = {}) => apiClient.get(API_ENDPOINTS.WARRANTY.CLAIMS, { params }),
  show: (id, params = {}) =>
    apiClient.get(API_ENDPOINTS.WARRANTY.CLAIM_DETAILS(id), { params }),
  create: (body) => apiClient.post(API_ENDPOINTS.WARRANTY.CLAIMS, body),
  update: (id, body) =>
    apiClient.put(API_ENDPOINTS.WARRANTY.CLAIM_DETAILS(id), body),

  assess: (id, body) =>
    apiClient.post(API_ENDPOINTS.WARRANTY.CLAIM_ASSESS(id), body),

  approve: (id, body) =>
    apiClient.post(API_ENDPOINTS.WARRANTY.CLAIM_APPROVE(id), body),

  reject: (id, body) =>
    apiClient.post(API_ENDPOINTS.WARRANTY.CLAIM_REJECT(id), body),

  fulfil: (id, body) =>
    apiClient.post(API_ENDPOINTS.WARRANTY.CLAIM_FULFIL(id), body),

  resolve: (id, body = {}) =>
    apiClient.post(API_ENDPOINTS.WARRANTY.CLAIM_RESOLVE(id), body),

  close: (id) =>
    apiClient.post(API_ENDPOINTS.WARRANTY.CLAIM_CLOSE(id), {}),

  rejectViaDelete: (id) =>
    apiClient.delete(API_ENDPOINTS.WARRANTY.CLAIM_DETAILS(id)),

  supplierClaim: (id, body) =>
    apiClient.post(API_ENDPOINTS.WARRANTY.SUPPLIER_CLAIM(id), body),

  issueDocument: (id, type) =>
    apiClient.post(API_ENDPOINTS.WARRANTY.ISSUE_DOCUMENT(id, type), {}),

  signDocument: (id, documentId, body) =>
    apiClient.post(
      API_ENDPOINTS.WARRANTY.SIGN_DOCUMENT(id, documentId),
      body,
    ),

  removeSignature: (claimId, documentId) =>
    apiClient.post(
      API_ENDPOINTS.WARRANTY.SIGN_DOCUMENT(claimId, documentId),
      {
        signature: null,
        signed_by_name: null,
      },
    ),

  // Available pickers for replacement / fulfilment
  getAvailableSerials: (productId, storeId) =>
    apiClient.get(API_ENDPOINTS.INVENTORY.SERIALS_AVAILABLE, {
      params: { product_id: productId, store_id: storeId },
    }),

  getAvailableBatches: (productId, storeId) =>
    apiClient.get(
      API_ENDPOINTS.INVENTORY.BATCHES_AVAILABLE(productId, storeId),
    ),

  // PDF report fetchers
  fetchPdfBlob: async (url, queryParams = {}) => {
    const res = await apiClient.get(url, {
      params: queryParams,
      responseType: "blob",
    });
    return new Blob([res.data], { type: "application/pdf" });
  },

  openPdfReport: async (url, queryParams = {}) => {
    const res = await apiClient.get(url, {
      params: queryParams,
      responseType: "blob",
    });
    const blob = new Blob([res.data], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");
    return blobUrl;
  },

  downloadPdfReport: async (url, filename = "document.pdf", queryParams = {}) => {
    const res = await apiClient.get(url, {
      params: queryParams,
      responseType: "blob",
    });
    const blob = new Blob([res.data], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    return blobUrl;
  },

  printPdfReport: async (url, queryParams = {}) => {
    const res = await apiClient.get(url, {
      params: queryParams,
      responseType: "blob",
    });
    const blob = new Blob([res.data], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);
    const printWindow = window.open(blobUrl, "_blank");
    if (printWindow) {
      printWindow.focus();
    }
    return blobUrl;
  },

  pdf: {
    intake: (id) => API_ENDPOINTS.REPORTS.WARRANTY_INTAKE(id),
    rejection: (id) => API_ENDPOINTS.REPORTS.WARRANTY_REJECTION(id),
    exchange: (id) => API_ENDPOINTS.REPORTS.WARRANTY_EXCHANGE(id),
    completion: (id) => API_ENDPOINTS.REPORTS.WARRANTY_COMPLETION(id),
    creditNote: (id) => API_ENDPOINTS.REPORTS.CREDIT_NOTE(id),
  },
};

export default warrantyApi;
